import * as React from "react"
import Dialog from "@mui/material/Dialog"
import {GlobalContext} from "../../context-provider/GlobalContextProvider"
import {DialogContent, DialogTitle} from "@mui/material"
import Content from "../Content"

const BaseDialog = () => {
    const {
        isDialogOpen,
        closeDialog,
        dialogContainer,
    } = React.useContext(GlobalContext)
    return (
        <Dialog
            onClose={closeDialog}
            aria-labelledby="customized-dialog-title"
            open={isDialogOpen}
        >   
            {dialogContainer?.text && <DialogTitle>{dialogContainer?.text}</DialogTitle>}
            <DialogContent px={6} pb={4} spacing={2}>
                {dialogContainer?.children.map(container => (
                    <Content key={container.id} child={container} />
                ))}
            </DialogContent>
        </Dialog>
    )
}

export default BaseDialog
